import SectionHeading from "@/components/SectionHeading";
import CTASection from "@/components/CTASection";
import { faqs } from "@/data/faqs";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";
import { HelpCircle } from "lucide-react";

const FAQs = () => {
  if (typeof document !== "undefined") document.title = "FAQs — School Smiles Australia";
  return (
    <>
      <section className="container-page pt-16 md:pt-24 pb-8" data-testid="faqs-hero">
        <div className="max-w-3xl">
          <span className="eyebrow"><HelpCircle size={14} strokeWidth={2.5}/> Frequently asked questions</span>
          <h1 className="mt-5 font-display font-extrabold text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-[#14324A]">
            Answers to the questions we hear most
          </h1>
          <p className="mt-5 text-[#4B6B86] text-lg leading-relaxed">
            Can't find your question? Our team is happy to help — send us a note via the contact page.
          </p>
        </div>
      </section>

      <section className="container-page py-12" data-testid="faqs-list">
        <div className="card-soft p-6 md:p-10">
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((f, i) => (
              <AccordionItem key={f.q} value={`item-${i}`} className="border-b border-[#E5F0FA] last:border-b-0" data-testid={`faq-item-${i}`}>
                <AccordionTrigger className="text-left font-display font-semibold text-[#14324A] hover:no-underline hover:text-[#1677C8] text-base md:text-lg py-5">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-[#4B6B86] leading-relaxed text-sm md:text-base pb-5">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>

      <div className="container-page"><CTASection testIdPrefix="faqs-cta" /></div>
    </>
  );
};

export default FAQs;
